import { jsx as n } from "react/jsx-runtime";
import { useMemo as U } from "react";
import { useAuth as B } from "@dcentralexpedientedigital/fe-shared/hooks/use-auth";
import { requestFn as T } from "@openapi-qraft/react";
import { allServices as A } from "../api/index.js";
import { RealtimeApiProvider as g } from "./realtime-api-provider.js";
import { TenantContext as $ } from "./tenant-context.js";
const j = ({
  children: i,
  config: e
}) => {
  var a;
  const {
    platform: { baseUrl: s, xTenantId: m },
    dataPlatform: { dlstBaseUrl: l, campaignBaseUrl: c },
    isLoggedIn: d,
    userId: u
  } = e, { auth: t } = B(), o = ((a = t == null ? void 0 : t.user) == null ? void 0 : a.access_token) ?? null, p = (r) => {
    switch (r) {
      case "dynamic-lists":
        return l;
      case "campaign":
        return c;
      default:
        return `${s}/${r}`;
    }
  }, f = U(
    () => A.reduce((r, [v, I]) => {
      const P = p(v);
      return /* @__PURE__ */ n(
        I.Provider,
        {
          value: {
            baseUrl: P,
            async requestFn(h, x) {
              return T(h, {
                ...x,
                headers: {
                  "X-Tenant-ID": m,
                  ...o ? { Authorization: `Bearer ${o}` } : {}
                }
              });
            }
          },
          children: r
        }
      );
    }, i),
    [s, o]
  );
  return /* @__PURE__ */ n($.Provider, { value: e.platform.xTenantId, children: /* @__PURE__ */ n(
    g,
    {
      isLoggedIn: d,
      tenantId: e.platform.xTenantId,
      userId: u,
      children: f
    }
  ) });
};
export {
  j as PlatformApiProvider
};
